<script setup lang="ts">
import './assets/style.scss'
import { useInventObjectTypesGroupModal } from './../modal/modal.ts'
import { VModal } from '@/shared/ui'
import { ref } from 'vue'
import { useTranslate } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { useSendInventObjectGroup } from './../modal/api.ts'
import { WObjectSubTypeSelect } from '@/widgets'

defineProps({
  isSystem: {
    type: Boolean,
    default: false,
  },
})

const model = useInventObjectTypesGroupModal()
const { send, isPending } = useSendInventObjectGroup()
const { trs } = useTranslate()
const route = useRoute()

const valid = ref(false)
const emits = defineEmits(['added'])

/** Список позиций */
const positions = [
  { title: trs('itf.position_prepend'), value: 'PREPEND' },
  { title: trs('itf.position_append'), value: 'APPEND' },
]

/** Список типов */
const types = [
  { title: trs('itf.group'), value: 'GROUP' },
  { title: trs('itf.list'), value: 'LIST' },
  { title: trs('itf.changes'), value: 'HISTORY' },
]

/**
 * Функция отправки формы
 */
const submitHandler = () => {
  model.data.catalog_invent_objects_type_id = Number(route.params.invent_object_type_id)
  send(model.data).then(() => {
    emits('added')
    model.clear()
  })
}
</script>

<template>
  <VModal v-model="model.open">
    <template #title>
      {{ $t('itf.create_group') }}
    </template>

    <VForm v-model="valid" @submit.prevent="submitHandler">
      <VTextField class="mt-2" :label="$t('itf.name')" v-model="model.data.name" />

      <VSelect :label="$t('itf.type')" v-model="model.data.type" :items="types" />

      <WObjectSubTypeSelect
        :label="$t('itf.list_type')"
        v-if="model.data.type === 'LIST'"
        v-model="model.data.list_invent_object_type_id"
      />

      <VCheckbox
        class="ml-2"
        density="compact"
        :label="$t('itf.open')"
        v-if="!isSystem"
        v-model="model.data.open"
      />

      <VCheckbox
        class="ml-2"
        density="compact"
        :label="$t('itf.is_tab')"
        v-if="!isSystem"
        v-model="model.data.is_tab"
      />

      <div class="form__btn_right">
        <VBtn color="default" @click="model.clear">{{ $t('itf.cancel') }}</VBtn>
        <VBtn type="submin" :loading="isPending">Сохранить</VBtn>
      </div>
    </VForm>
  </VModal>
</template>
